import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspectInbox extends BaseModelAPI {
	static entity = 'finishgoodqualityinspectinbox';
	static entityName = 'finishgoodqualityinspectinbox';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.qtyBefore = 0;
			this.qtyAfter = 0;
			this.qtyPending = 0;
			this.qtyNg = 0;
			this.metodeQcId = '';
			this.metodeQc = {};
			this.partId = '';
			this.part = {};
			this.workOrderProcessDetailId = '';
			this.workOrderProcessDetail = {};
			this.finishGoodQualityInspectNgInboxs = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}